export function getEnvDomain() {
    var _a;
    try {
        return ((_a = location === null || location === void 0 ? void 0 : location.hostname) === null || _a === void 0 ? void 0 : _a.split('.')[0]) || "unknow";
    }
    catch (e) {
        return "unknow";
    }
}
export function getUrl() {
    var _a;
    return ((_a = window === null || window === void 0 ? void 0 : window.location) === null || _a === void 0 ? void 0 : _a.href) || "unknow";
}
export function getHost() {
    var _a;
    return ((_a = window === null || window === void 0 ? void 0 : window.location) === null || _a === void 0 ? void 0 : _a.host) || "unknow host";
}
//# sourceMappingURL=domain.js.map